export default {
  /* Buttons */
  bt: {
    export: "Export (Max 500 rows at a time)",
    createSingleDraft: "Create Single Draft",
    batchAdd: "Batch Add",
    editEmailTemplate: "Edit Email Templates",
    cancel: "Cancel",
    confirmAdd: "Add",
    retry: "Retry",
    saveSettings: "Save Settings",
    saving: "Saving..."
  },
  /* Common fields or utility function fields */
  common: {
    businessType: "Business Type",
    businessTypePlaceholder: "Select Business Type",
    queryTime: "Query Time",
    businessTypeGM: "GM",
    businessTypeCX: "CX",
    businessTypeGMCX: "GMCX",
    sequence: "No.",
    startTime:"Start Time",
    endTime:"End Time",
    creator:"Creator",
    updater:"Updater",
    createTime:"Create Time",
    updateTime:"Update Time",
    phone:"Phone",
    email:"Email",
    idNumber:"ID Number",
    status:"Status",
    remark:"Remark"
  },
  /* Common Messages and Tips */
  msg: {
    apiError: "(Status {status}) {message}",
    networkError: "Cannot connect to the server, please check your network connection.",
    unknownError: "An unknown error occurred.",
    resetSuccess: "All fields and filters have been reset."
  },
  listCommon: {
    pno: "PNO",
    pnoPlaceholder: "Enter single or multiple PNOs, separated by ',' or ', '",
    templateType: "Template Type (for single add)",
    templateTypePlaceholder: "Please select",
    accountNo: "Account No",
    proposalNo: "Proposal No",
    paidAmount: "Paid Amount",
    gatewayName: "Gateway Name",
    name: "Name",
    currency: "Currency",
    emailSentTime: "Email Sent Time",
    proposalStatus: "Proposal Status",
    lastUpdateTime: "Last Update Time",
    depositDiscrepancyProcessTime: "Discrepancy Process Time"
  },
  listMsg: {
    pnoRequiredForSingle: "PNO field cannot be empty when creating a single draft.",
    pnoRequiredForBatch: "PNO field cannot be empty for batch add.",
    pnoBatchLimit: "The number of PNOs for batch add cannot exceed 50.",
    batchAddConfirmTitle: "Batch Add Confirmation",
    classifying: "Classifying, please wait...",
    gmPnos: "GM Type PNOs",
    cxPnos: "CX Type PNOs",
    invalidPnos: "The following are invalid, existing, canceled, or approved PNOs and will not be used to create drafts",
    invalidPnoError: "Invalid, existing, canceled, or approved PNO!!!",
    getTemplateFailed: "Failed to get filled email template.",
    classifyFailed: "Classification failed: {error}",
    getTemplateError: "Error getting {templateType} template: {error}",
    extensionAPIError: "Google Chrome extension communication API not detected.",
    extensionIdError: "Invalid Google Chrome extension ID",
    extensionCommError: "Failed to communicate with the extension: {message}",
    extensionOpError: "Extension operation failed: {error}",
    extensionSuccess: "Request sent to extension!",
    extensionOpSuccess: "Extension successfully executed action: {action}",
    extensionOnlyMessage: "This feature is only available in Google Chrome browser with the corresponding extension installed.",
    exportListTitle: "Deposit Discrepancy Email Sending List",
    editEmailTemplateTitle: "Edit Email Templates",
    loadingTemplate: "Loading templates...",
    loadTemplateFailed: "Failed to load templates:",
    templateInfoPart1: "When creating a draft, the following templates will be used for auto-filling. You can use",
    templateInfoPart2: "as a placeholder.",
    templateSectionGM: "GM Type Templates",
    templateSectionCX: "CX Type Templates",
    recipientTemplate: "Recipient Template ({type}):",
    subjectTemplate: "Subject Template ({type}):",
    bodyTemplate: "Body Template ({type}):",
    recipientPlaceholder: "e.g., {example}",
    subjectPlaceholderGM: "e.g., GM Deposit Discrepancy - PNO: {pno}",
    subjectPlaceholderCX: "e.g., CX Deposit Discrepancy - PNO: {pno}",
    bodyPlaceholderGM: "GM related body template...",
    bodyPlaceholderCX: "CX related body template...",
    saveSuccess: "Email templates updated successfully!",
    saveError: "Save failed: {error}"
  },
  statsCommon: {
    statsDate: "Date",
    statsSize: "Quantity",
    statsSmallAmountTransfer: "Small Amount Transfer: Less than RMB 10,000",
    statsLargeAmountTransfer: "Large Amount Transfer: More than RMB 10,000",
    statsAlipay: "Alipay",
    statsUSDT: "USDT",
    statsDigitalRMB: "Digital RMB",
    statsCloudQuickPass: "Cloud Quick Pass",
    statsCardCode: "Card Code",
    statsWeChat: "WeChat",
    statsYunPayTransfer: "YunPay Transfer",
    statsOthers: "Others",
    statsDiscrepancyAmountCNY: "Discrepancy Amount CNY",
    statsDiscrepancyAmountUSD: "Discrepancy Amount USD",
    statsDiscrepancyAmountOthers: "Discrepancy Amount (Others)",
    statsTotalProcessingTime: "Total Processing Time",
    statsAverageProcessingTime: "Average Processing Time"
  },
  statsMsg: {
    exportListTitle: "Discrepancy Statistics"
  }
};
